import {createStore as reduxCreateStore} from "redux";
import combineReducers from "./reducers";

const initialState = {};

function createStore() {
    return reduxCreateStore(combineReducers(), initialState);
}

export default createStore;